import React, { useState } from "react";
import { Check, Copy, ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { tf } from "@/i18n";

export const ShareLink = ({ label, url, hint, testId }) => {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
    } catch (error) {
      const helper = document.createElement("textarea");
      helper.value = url;
      document.body.appendChild(helper);
      helper.select();
      document.execCommand("copy");
      document.body.removeChild(helper);
    }
    setCopied(true);
    toast.success(tf("share.copied", { label }));
    setTimeout(() => setCopied(false), 1800);
  };

  return (
    <div className="rounded-lg surface-2 p-3">
      <p className="text-[10px] font-semibold uppercase tracking-[0.14em] text-[color:var(--muted-ink)]">{label}</p>
      <div className="mt-1 flex items-center gap-2">
        <code
          className="font-num min-w-0 flex-1 truncate rounded-md border border-[color:var(--line)] bg-white px-2 py-1.5 text-[11px]"
          data-testid={`${testId}-url`}
        >
          {url}
        </code>
        <Button size="sm" variant="outline" className="h-8 shrink-0 px-2" onClick={copy} data-testid={`${testId}-copy-button`}>
          {copied ? <Check className="h-3.5 w-3.5" /> : <Copy className="h-3.5 w-3.5" />}
        </Button>
        <Button size="sm" variant="outline" className="h-8 shrink-0 px-2" asChild data-testid={`${testId}-open-button`}>
          <a href={url} target="_blank" rel="noreferrer">
            <ExternalLink className="h-3.5 w-3.5" />
          </a>
        </Button>
      </div>
      {hint ? <p className="mt-1.5 text-[11px] text-[color:var(--ink-soft)]">{hint}</p> : null}
    </div>
  );
};

export default ShareLink;
